const globalParams = {
  set(params) {
    const self = this;
    Object.keys(params).forEach((key) => {
      try {
        self[key] = JSON.parse(params[key]);
      } catch (e) {
        self[key] = params[key];
      }
    });

    if (self.param) {
      try {
        Object.assign(self, self.param);
      // eslint-disable-next-line no-empty
      } catch (e) {}
    }
  },

  clear() {
    const self = this;
    Object.keys(self).forEach((key) => {
      if (key !== 'set' && key !== 'clear') {
        delete self[key];
      }
    });
  },
};

export default globalParams;
